import React from 'react'
import ProfileContainer from './ProfileContainer'

const Profile = (props, handleLanguage) => (
  <ProfileContainer {...props} handhandleLanguageleClick={handleLanguage} />
)

export default Profile



// WEBPACK FOOTER //
// src/components/Profile/NavBarProfile/index.js